import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import ButtonComponent from "../../../../shared/components/ButtonComponent";
import { SearchInput } from "../../../../shared/components/SearchInput";
import { debounce } from "lodash";
import {
  DownloadOutlined,
  CaretDownOutlined,
  FilterOutlined,
  RightOutlined,
  DownOutlined,
} from "@ant-design/icons";
import {
  Table,
  Dropdown,
  Menu,
  Button,
  Spin,
  Modal,
  Upload,
  Badge,
  Row,
  Col,
} from "antd";
import faker from "faker";
import "./instituteTeachers.scss";
import InstituteTeacherForm from "./InstituteTeacherForm";
import CardMenu from "../../../../shared/components/CourseComponents/CardMenu";
import { generatePath, useHistory, useParams } from "react-router-dom";
import Filters from "../../../../shared/components/Filters";
import { Form, Formik, FormikValues } from "formik";
import BranchService from "../../../../services/InstituteService/branch.service";
import { deserialize } from "serializr";
import { BranchMetaModel } from "../../../../models/InstituteModel/branches.model";
import DropdownField from "../../../../shared/components/DropdownField";
import { InstituteTutorService } from "../../../../services/InstituteService/tutor.service";
import { INSTITUTE_TEACHER_VIEW } from "../../../../routes/routeConstants/appRoutes";
import {
  InstituteTutorFiltersModel,
  InstituteTutorModel,
  InstituteTutorSectionsModel,
} from "../../../../models/InstituteModel/tutor.model";
import DeleteAlert from "../../../../shared/components/DeleteAlert";
import { convertJSONToFormData } from "../../../../shared/utils/converJsonToFormData";
import { renderErrors } from "../InstituteStudents";
import { convertJsonToXslx } from "../../../../shared/utils/xlsxConverter";
import { TutorXslxHeaders } from "../../../../enums/tutorXslxHeaders";
import {
  BASE_URL,
  INSTITUTE_TUTORS_EXISITING_DATA,
} from "../../../../routes/routeConstants/apiRoutes";
import { UploadFile } from "antd/lib/upload/interface";

interface InstituteTeachersProps { }

const InstituteTeachers: FC<InstituteTeachersProps> = (props: any) => {
  const { user } = props;
  const [showFilters, setFilterVisibility] = useState(false);
  const [showForm, setFormVisibility] = useState(false);
  const [currentTeacher, setCurrentTeacher] = useState<InstituteTutorModel>();
  const history = useHistory();
  const params: any = useParams();
  const formRef = useRef<any>();
  const [filterValues, setFilterValues] = useState<any>({
    branchId: null,
  });
  const [branches, setBranches] = useState<BranchMetaModel[]>([]);
  const [instituteTeachers, setInstituteTeachers] = useState<
    InstituteTutorModel[]
  >([]);
  const [deleteVisible, setDeleteVisibility] = useState(false);
  const [showSpinModal, setSpinModalVisibility] = useState(false);
  const [uploadErrors, setUploadErrors] = useState<any>(null);
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const handleSearch = (search: string, branchId?: number) => {
    fetchTutors({
      pageSize: pagination.pageSize,
      instituteId: params?.instituteId,
      name: search,
      branchId,
    });
  };
  const debouncedSearchHandler = useMemo(() => debounce(handleSearch, 500), []);

  const handleTemplateExcel = () => {
    convertJsonToXslx("tutors_template.xlsx", "Tutors", [
      TutorXslxHeaders.NAME,
      TutorXslxHeaders.PHONE_NUMBER,
      TutorXslxHeaders.BRANCH_ID,
      TutorXslxHeaders.EMAIL,
      TutorXslxHeaders.SECTION_SUBJECTS,
      TutorXslxHeaders.CLASS_TEACHER,
      TutorXslxHeaders.PASSWORD,
    ]);
  };
  const filtersHandler = (values: FormikValues) => {
    setFilterValues(values);
    setFilterVisibility(false);
    fetchTutors({
      instituteId: params?.instituteId,
      branchId: values?.branchId,
      pageSize: pagination.pageSize
    });
  };

  const fetchTutors = (params) => {
    setLoading(true);

    InstituteTutorService.fetchInstituteTutors(
      params,
      (teachers, total_tutors) => {
        setInstituteTeachers(teachers);
        setPagination({ ...pagination, total: total_tutors, current: params.currentPage, pageSize: params.pageSsize })
        setLoading(false);
      },
      () => { },
      () => { }
    );

  };

  const uploadBulkTutors = (file: any) => {
    setSpinModalVisibility(true);
    setUploadErrors(null);
    const payload = convertJSONToFormData({
      tutor_upload: { attachment: file },
    });
    InstituteTutorService.createBulkInstituteTutors(
      payload,
      () => {
        refreshHandler();
        setSpinModalVisibility(false);
      },
      (errors) => {
        setUploadErrors(errors);
      },
      () => { }
    );
  };

  useEffect(() => {
    fetchBranches();
    fetchTutors({ instituteId: params?.instituteId, currentPage: pagination.current, pageSize: pagination.pageSize });
  }, []);

  const handleTableChange = (pageInfo) => {
    fetchTutors({ instituteId: params?.instituteId, currentPage: pageInfo.current, pageSize: pageInfo.pageSize });
  };

  const fetchBranches = () => {
    BranchService.fetchBranches(
      { institute_id: params?.instituteId },
      (data) => {
        let meta = deserialize(BranchMetaModel, data) as BranchMetaModel[];
        setBranches(meta);
      },
      () => { },
      () => { }
    );
  };

  const refreshHandler = () => {
    fetchTutors({ instituteId: params?.instituteId });
    setCurrentTeacher(undefined);
  };

  const deleteTutor = () => {
    if (currentTeacher?.id)
      InstituteTutorService.deleteInstituteTutor(
        currentTeacher?.id,
        () => {
          refreshHandler();
          setDeleteVisibility(false);
        },
        () => { },
        () => { }
      );
  };

  return (
    <div className="institute-teachers">
      <Modal
        visible={showSpinModal}
        title={null}
        footer={null}
        closable={uploadErrors ? true : false}
        centered
        onCancel={() => setSpinModalVisibility(false)}
        className="institute-teachers-spin__container"
      >
        <Spin
          className="institute-teachers__spin"
          tip="Creating tutors..."
          spinning={!uploadErrors}
        ></Spin>
        {uploadErrors &&
          renderErrors(uploadErrors)?.map((value, index) => {
            return <p className="error__text">{value}</p>;
          })}
      </Modal>
      <DeleteAlert
        title={currentTeacher?.fullName}
        detail={""}
        visible={deleteVisible}
        setVisible={setDeleteVisibility}
        deleteText="tutor"
        deleteWarning="This tutor will be deleted permanently"
        handleDelete={deleteTutor}
      />
      <div className="header__wrapper">
        <div className="header__left">
          <SearchInput
            placeholder={"Search by name or email"}
            onChange={(search) =>
              debouncedSearchHandler(search, filterValues?.branchId)
            }
          />
          <Button onClick={() => setFilterVisibility(true)}>
            <span>
              <FilterOutlined />
            </span>
            Apply Filter
            {filterValues?.branchId && <Badge count={1} />}
          </Button>
        </div>
        <div className="header__right">
          <Dropdown
            overlayClassName="download__dropdown"
            trigger={["click"]}
            overlay={
              <Menu>
                <Menu.Item onClick={handleTemplateExcel}>
                  <p>Template Excel</p>
                </Menu.Item>
                <Menu.Item>
                  <p
                    onClick={() => {
                      var element = document.createElement("a");
                      element.href =
                        BASE_URL +
                        INSTITUTE_TUTORS_EXISITING_DATA +
                        `?institute_id=${params?.instituteId}`;
                      element.click();
                    }}
                  >
                    Existing Data
                  </p>
                </Menu.Item>
              </Menu>
            }
            placement="bottomRight"
            arrow
          >
            <Button>
              <span>
                <DownloadOutlined />
              </span>
              Download
              <span>
                <CaretDownOutlined />
              </span>
            </Button>
          </Dropdown>
          {(user?.roleName === 'admin' || user.email === "ssvmadmin@mail.com") && (
            <React.Fragment>
              <Upload
                className="header-bulk-upload"
                showUploadList={false}
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={({ file }: { file: UploadFile }) => {
                  if (file?.status !== "uploading") {
                    uploadBulkTutors(file?.originFileObj);
                  }
                }}
              >
                <ButtonComponent buttonContent="Bulk Upload" type="primary" />
              </Upload>
              <ButtonComponent
                className="header-add-btn"
                buttonContent={"Add"}
                type="primary"
                onClick={() => setFormVisibility(true)}
              />
            </React.Fragment>)
          }
        </div>
      </div>
      <InstituteTeacherForm
        visible={showForm}
        closeHandler={() => {
          setFormVisibility(false);
          setCurrentTeacher(undefined);
        }}
        data={currentTeacher}
        refreshList={refreshHandler}
      />
      <Table
        className="institute-teachers__table"
        pagination={pagination}
        onChange={handleTableChange}
        loading={loading}
        expandable={{
          expandedRowRender: (record) =>
            record?.tutorClassRooms?.length ? (
              <div className="institute-teachers__table-expanded">
                <Row>
                  <Col span={4}>
                    <div className="head">Class</div>
                  </Col>
                  <Col span={4}>
                    <div className="head">Sections</div>
                  </Col>
                  <Col span={16}>
                    <div className="head">Subjects</div>
                  </Col>
                </Row>
                {record?.tutorClassRooms?.map((classroom) => {
                  return classroom?.tutorSections?.map((section) => {
                    return (
                      <Row>
                        <Col span={4}>
                          <div className="value">
                            {classroom?.name}{" "}
                            {classroom?.classTeacher && (
                              <span className="class-teacher">
                                Class Teacher
                              </span>
                            )}
                          </div>
                        </Col>
                        <Col span={4}>
                          <div className="value">{section?.name}</div>
                        </Col>
                        <Col span={16}>
                          <div className="value">
                            {section?.tutorSubjects?.map((subject, index) => {
                              return `${subject?.name}${section?.tutorSubjects?.length
                                ? section?.tutorSubjects?.length - 1 !== index
                                  ? ", "
                                  : ""
                                : ""
                                }`;
                            })}
                          </div>
                        </Col>
                      </Row>
                    );
                  });
                })}
              </div>
            ) : null,
          expandIcon: ({ expanded, onExpand, record }) =>
            record?.tutorClassRooms?.length ? expanded ? (
              <DownOutlined
                className="expandable__icon"
                onClick={(e) => onExpand(record, e)}
              />
            ) : (
              <RightOutlined
                className="expandable__icon"
                onClick={(e) => onExpand(record, e)}
              />
            ) : null,
        }}
        columns={[
          {
            key: "fullName",
            dataIndex: "fullName",
            title: "Name",
            sorter: (a: any, b: any) => a?.fullName.localeCompare(b?.fullName),
            width: 200,
            render: (text, record) => (
              <div
                className="cursor-pointer"
                onClick={() =>
                  history.push(
                    generatePath(INSTITUTE_TEACHER_VIEW, {
                      teacherId: record?.id,
                      instituteId: params?.instituteId,
                    })
                  )
                }
              >
                {text}
              </div>
            ),
          },
          {
            key: "id",
            dataIndex: "id",
            title: "Teacher ID",
            sorter: (a: any, b: any) => a?.id - b?.id,
            width: 150,
          },
          {
            key: "branch",
            dataIndex: "branch",
            title: "Branch",
            sorter: (a: any, b: any) =>
              a?.branch?.name.localeCompare(b?.branch?.name),
            render: (branch) => branch?.name,
          },
          {
            key: "phoneNumber",
            dataIndex: "phoneNumber",
            title: "Phone Number",
            sorter: (a: any, b: any) =>
              a?.phoneNumber.localeCompare(b?.phoneNumber),
          },
          {
            key: "email",
            dataIndex: "email",
            title: "Email ID",
            sorter: (a: any, b: any) => a?.email.localeCompare(b?.email),
          },
          user?.roleName === 'admin' || user.email === "ssvmadmin@mail.com" ?
          {
            key: "action",
            render: (_, record) => (
              <div className="institute-teachers-table__menu">
                <CardMenu
                  handleVisibleChange={(visible) => {
                    if (visible) setCurrentTeacher(record);
                    else setCurrentTeacher(undefined);
                  }}
                  menuText="Teacher"
                  handleDelete={() => {
                    setDeleteVisibility(true);
                  }}
                  handleEdit={() => {
                    setFormVisibility(true);
                  }}
                />
              </div>
            ),
          }:{},
        ]}
        dataSource={instituteTeachers}
      />
      <Formik
        initialValues={filterValues}
        onSubmit={filtersHandler}
        enableReinitialize
        innerRef={formRef}
      >
        {({ values, setFieldValue, resetForm, handleSubmit }) => (
          <Filters
            expand={showFilters}
            handleReset={() => {
              setFilterValues({ branchId: null });
              resetForm({ values: {} });
              refreshHandler();
              setFilterVisibility(false);
            }}
            handleApply={handleSubmit}
            closeHandler={() => {
              setFilterVisibility(false);
            }}
          >
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="institute-teacher-details-filters">
                <div className="filter-form__input">
                  <div className="filter-form__label">Branch</div>
                  <DropdownField
                    name="branchId"
                    placeholder="Select branch"
                    options={branches}
                    value={values?.branchId}
                    onChange={(value) => {
                      setFieldValue("branchId", value);
                    }}
                    showSearch={false}
                    optionFilterProp="label"
                  />
                </div>
              </div>
            </Form>
          </Filters>
        )}
      </Formik>
    </div>
  );
};

export default InstituteTeachers;
